import { Link } from 'react-router-dom';
import styled from 'styled-components';

// Vendor-first line for cards that show items from more than one Vendor.
const VendorEyebrow = styled(Link)`
  align-items: center;
  color: #475467;
  display: inline-flex;
  font-size: 12px;
  font-weight: 500;
  gap: 6px;
  letter-spacing: 0.01em;

  &::before {
    background: #7F56D9;
    border-radius: 2px;
    content: '';
    height: 10px;
    width: 3px;
  }

  &:hover { color: #6941C6; text-decoration: underline; }
`;

export default VendorEyebrow;
